import { createFileRoute } from "@tanstack/react-router";
import LawnMowerGuide from "@/pages/LawnMowerGuide";

const YEAR = new Date().getFullYear();
const PAGE_URL = "https://www.garden-review.co.uk/best-lawn-mowers-uk";

export const Route = createFileRoute("/best-lawn-mowers-uk")({
  head: () => {
    const title = `Best Lawn Mowers UK ${YEAR}: Tested & Compared`;
    const description = `Find the right lawn mower for your UK garden in ${YEAR} — petrol, cordless and robotic picks with live price comparison.`;
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "article" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
      ],
      links: [{ rel: "canonical", href: PAGE_URL }],
    };
  },
  component: LawnMowerGuide,
});
